class NotificationCenter {
    constructor() {
        this.observers = {};
    }

    observe(notificationName, callback) {
        if (typeof notificationName !== "string" || typeof callback !== "function") {
            throw new Error("Invalid arguments for observe: expected a string and a function.");
        }
        if (!this.observers[notificationName]) {
            this.observers[notificationName] = [];
        }
        this.observers[notificationName].push(callback);
    }

    // Remove an observer callback for a given notification name.
    removeObserver(notificationName, callback) {
        if (typeof notificationName !== "string" || typeof callback !== "function") {
            throw new Error("Invalid arguments for removeObserver: expected a string and a function.");
        }
        if (this.observers[notificationName]) {
            var index = this.observers[notificationName].indexOf(callback);
            if (index > -1) {
                this.observers[notificationName].splice(index, 1);
            }
        }
    }

    // Post a notification with an optional object.
    post(notificationName, object) {
        if (typeof notificationName !== "string") {
            throw new Error("Invalid notification name: expected a string.");
        }
        var callbacks = this.observers[notificationName];
        if (callbacks && callbacks.length) {
            // Create a shallow copy in case the observer list is modified during iteration.
            callbacks.slice().forEach(function(callback) {
                try {
                    callback(object);
                } catch (error) {
                    console.error(`Error in notification callback for “${notificationName}” : ${error}`);
                }
            });
        }
    }
}

export const notificationCenter = new NotificationCenter();
